import 'css-chunksrc/client/scenes/projectsTransfer/destinationsList/styles.scss';export default {
  "zonesList": "_zonesList_o93v4_1",
  "item": "_item_o93v4_8",
  "avatar": "_avatar_o93v4_14",
  "selectedItems": "_selectedItems_o93v4_19",
  "label": "_label_o93v4_23",
  "zone": "_zone_o93v4_1"
};